module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-35892068143b091b5324387dabd711ff.png";